<template>
    <div class="mb-3">
        <router-link class="service-card card text-dark overflow-hidden shadow-sm text-decoration-none position-relative h-100"
                     v-bind:to="`/services/${ service._id }`">
            <div class="status-bar w-100"
                 v-bind:class="{ 'approved': service.approved, 'edits-pending': editsPending.length > 0 }">
            </div>
            <div class="row no-gutters flex-md-row flex-grow-1">
                <div class="col-lg-7 order-1 order-lg-0 p-3 d-flex flex-column position-static h-100">
                    <strong class="d-inline-block mb-0 text-primary">
                        <color-dot size="sm"
                                   v-bind:color="category.color">
                        </color-dot>
                        {{ category.name }}
                    </strong>
                    <h4 class="font-weight-bolder mb-auto">
                        {{ name }}
                    </h4>
                    <!-- <p class="card-text mb-auto">
                        testing
                    </p> -->

                    <div class="d-flex flex-row align-items-center">
                        <div class="mr-2">
                            <b-avatar variant="light"
                                      v-bind:src="`${ $config.apiUrl }/${ $config.apiVersion }/user/avatar/${ owner.avatar }`">
                            </b-avatar>
                        </div>
                        <div class="flex-grow-1">
                            <h5 class="font-weight-bold mb-0">
                                {{ owner.name }}
                            </h5>
                            <p class="mb-0">
                                {{ owner.email }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 order-0 order-lg-1 thumbnail bg-light d-flex h-100">
                    <img class="w-100"
                         v-bind:alt="name"
                         v-bind:src="`${ $config.apiUrl }/${ $config.apiVersion }/service/image/${ photo }`">
                    <div class="brand position-absolute bg-white rounded shadow-sm overflow-hidden"
                         v-if="logo">
                        <img class="w-100"
                             v-bind:alt="name"
                             v-bind:src="`${ $config.apiUrl }/${ $config.apiVersion }/service/image/${ logo }`">
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
    import {
        BAvatar,
    } from "bootstrap-vue";
    import ColorDot from "../ColorDot";

    export default {
        name: "ServiceCard",
        components: {
            ColorDot,
            BAvatar,
        },
        props: {
            "service": {
                type: Object,
                required: true,
            },
        },
        data () {
            return {

            };
        },
        computed: {
            editsPending () {
                return this.service && this.service.editsPending ? this.service.editsPending : [];
            },

            name () {
                return this.service ? this.service.name : "";
            },

            category () {
                return this.service ? this.service.category : "";
            },

            users () {
                return this.$store.getters["users/all"];
            },

            owner () {
                return this.service && this.service.owner ? this.service.owner : {};
            },

            photo () {
                if (this.service) {
                    return this.service.photo[0];
                }
                return "";
            },

            logo () {
                if (this.service) {
                    return this.service.logo;
                }
                return "";
            },
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../node_modules/bootstrap/scss/functions";
    @import "../../../node_modules/bootstrap/scss/variables";
    @import "../../../node_modules/bootstrap/scss/mixins/breakpoints";

    .service-card {
        min-height: 250px;

        transition:
            box-shadow 200ms ease,
            transform 250ms ease-in-out;

        &:hover,
        &:focus {
            transform: scale(1.025);
            box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
        }

        .status-bar {
            height: 6px;
            background-color: $secondary;
            transition: background-color 250ms ease-in-out;

            &.approved {
                background-color: $success;
            }

            &.edits-pending {
                background-color: $warning !important;
            }
        }

        .thumbnail {
            max-height: 250px;
            min-height: 200px;

            @include media-breakpoint-up(md) {
                max-height: 275px;
            }

            & > img {
                object-fit: cover;
            }
        }

        .brand {
            height: 50px;
            width: 50px;

            bottom: 5px;
            right: 5px;
        }
    }
</style>
